import { pageProgressMap, getPageProgressIndex, progressToPathMap, pathMap } from '@/utils/contants/caseSimulation';
export const curPageProgressIsCompleted = (curStage, targetStage) => {
    let currentPageIndex = getPageProgressIndex(pageProgressMap[curStage]);
    let targetIndex = getPageProgressIndex(targetStage);
    console.log(currentPageIndex, targetIndex, 'currentPageIndex, targetIndex');
    if (currentPageIndex < targetIndex) {
        return 'uncompleted';
    }
    if (currentPageIndex > targetIndex) {
        return 'completed';
    }
    if (targetIndex === currentPageIndex) {
        return 'ing';
    }
};
export const getToPathByStage = (stage) => {
    return progressToPathMap[stage] || pathMap['background'];
};
